export interface StatisticState {
  callStatisticDetail: CallDetailItem[],
  callStatisticDetailFlag?: string,
  callStatisticDetailIncoming?: DetailIncomingItem[];
  callDetailEvents?: CallDetailEventsItem[];

  callStatisticGroup?: CallGroupItem[],
  callStatisticGroupMessageCount?: number,
  callStatisticGroupSummary?: CallGroupSummary,
  callStatisticGroupIncoming?: CallGroupIncomingItem[],
  callStatisticGroupIncomingMessageCount?: number,
  callStatisticGroupIncomingSummary?: CallGroupIncomingSummary,
  callGroupings: {
    callGroup: string[],
    callGroupByOptionally: string[],
    callGroupByIncoming: string[],
    callGroupByOptionallyIncoming: string[],
  },
}

export class DetailFilterParams {
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  start_date_from?: string = undefined;
  start_date_to?: string = undefined;
  end_date_from?: string = undefined;
  end_date_to?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: string = undefined;
  operator?: string = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mt";
  }
}

export interface CallDetailItem {
  id: string,
  create_date: string,
  originator: string,
  recipient: string,
  partner: string,
  service_provider: string,
  content: string,
  status: string,
  error_code: number|null,
}
export interface CallDetailInfoItem {
  create_date: string;
  id: string;
  status: string;
  recipient: string;
  broker_account_login: string;
  bulk_id: string;
  connection_type: string;
  content: string;
  country: string;
  duration: string;
  ext_id1: string;
  ext_id2: string;
  ext_id3: string;
  ext_id4: string;
  ext_id5: string;
  message_direction: string;
  message_type: string;
  operator: string;
  originator: string;
  partner: string;
  service_provider: string;
  partner_user_login: string;
  template_id: number | null;
  partner_price: number | null;
  message: string,
  region: string,
  start_date: string,
  end_date: string,
  external_id: string,
  ring_duration: string,
  mcc: string,
  mnc: string,
  provider_price: number | null,
  parent_message_id: number | null,
  parent_message_transport: string,
  priority: string,
  error_code: number | null,
  error_description: string,
  module: string,
  provider_message_id: string,
  provider_protocol: string,
}

// - - -

export class CallGroupFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  originator?: string = undefined;
  service_provider?: string = undefined;
  partner?: string = undefined;
  country?: string = undefined;
  operator?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: string = undefined;
  broker_account_login?: number = undefined;
  message_type?: number = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mt";
  }
}

export interface CallGroupItem {
  date?: string;
  totalRow: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  operator?: string;
  template_id?: string;
  bulk_id?: string;
  finished: number;
  not_answered: number;
  failed?: number;
  rejected: number;
  buffered?: number;
  deferred?: number;
  error: number;
  duration: string;
  total: number;
  partner_price: number;
  provider_price: number;
  messages_summary?: CallGroupSummary;
}

export interface CallGroupSummary {
  total: number;
  finished: number;
  not_answered: number;
  failed?: number;
  rejected: number;
  deferred?: number;
  buffered?: number;
  duration: string;
  partner_price: number;
  provider_price: number;
  error: number;
}

// - - -

export class CallGroupIncomingFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  partner?: string = undefined;
  service_number?: string = undefined;
  originator_operator?: string = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mo";
  }
}

export interface CallGroupIncomingSummary {
  total: number;
  finished: number;
  error: number;
  duration: string;
}

export interface CallGroupIncomingItem {
  date?: string;
  service_number?: string;
  partner?: string;
  originator_operator?: string;
  finished: number;
  error: number;
  total: number;
  duration: string;
}

export class DetailIncomingFilterParams {
  id?: string = undefined;
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mo";
  }
}

export interface DetailIncomingItem {
  id: string;
  create_date: string;
  originator: string;
  service_number: string;
  partner: string;
  content: string;
  status: string;
  error_code?: number;
}

export interface DetailIncomingItemInfo extends DetailIncomingItem {
  start_date: string;
  end_date: string;
  duration: string;
  module: string;
  originator_operator?: string;
  originator_country?: string;
  error_description?: string;
}

export interface CallTemplateFileUpload {
  partner_user_id: number;
  name: string;
  base64: string;
  md5: string;
}

export interface CallDetailEventsItem {
  date: string;
  name: string;
  data: string;
  duration: string;
}

export class CallDetailEventsFilterParams {
  date_from: string;
  date_to: string;
  name?: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}
